import useAuth from "src/hooks/useAuth";

export default function useHasAdditionalCharges(project, direction = 'inbound') {
  const { user } = useAuth();
  const { settings } = user.company;

  const manuallyEnabled = settings?.additional_billing_wizard_steps || project?.receivingWizardBillingStep;
  const hasEnabledRates = checkForEnabledRates(project, direction);

  return manuallyEnabled || hasEnabledRates;
}

function checkForEnabledRates(project, direction) {
  if (!project) return false;

  const enabledKey = direction === 'inbound' ? 'inbound_enabled' : 'outbound_enabled';

  // Check all rate categories for enabled rates
  const rateCategories = [
    project.laborRates,
    project.materialRates, 
    project.openInspectRates,
    project.equipmentRates
  ];

  return rateCategories.some(rateCategory => {
    if (!rateCategory || typeof rateCategory !== 'object') return false;

    return Object.values(rateCategory).some(rateItem => {
      return rateItem && typeof rateItem === 'object' && rateItem[enabledKey] === true;
    });
  });
}
